module.exports = __webpack_public_path__ + "static/media/flikidsEnglish.91feeafd.jpg";